import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LaboratorioService } from 'src/app/services/laboratorio/laboratorio.service';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-laboratorios',
  templateUrl: './laboratorios.component.html',
  styleUrls: ['./laboratorios.component.scss'],
  standalone: false
})
export class LaboratoriosComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  isDtInitialized = false;

  public laboratorios: any[] = [];
  public cargando = false;
  public guardando = false;

  public nuevoLaboratorio = '';
  public editarLaboratorio = '';
  public idLaboratorioEditar = 0;

  constructor(
    private laboratorioService: LaboratorioService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order: [[0, 'asc']],
      language: LanguageApp.spanish_datatables
    };

    this.obtenerLaboratorios();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  get token(): string {
    return localStorage.getItem('token') || '';
  }

  obtenerLaboratorios() {
    this.cargando = true;
    this.laboratorioService.listarLaboratorios(this.token).subscribe({
      next: (resp: any) => {
        this.laboratorios = Array.isArray(resp?.rows) ? resp.rows : [];
        if (!this.isDtInitialized) {
          this.dtTrigger.next(null);
          this.isDtInitialized = true;
        } else {
          this.rerender();
        }
        this.cargando = false;
      },
      error: () => {
        this.laboratorios = [];
        this.cargando = false;
      }
    });
  }

  private rerender(): void {
    if (!this.dtElement) return;
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  abrirModalAgregar(modal: any) {
    this.nuevoLaboratorio = '';
    this.modalService.open(modal, { centered: true });
  }

  abrirModalEditar(modal: any, lab: any) {
    this.idLaboratorioEditar = Number(lab.COD_LAB);
    this.editarLaboratorio = String(lab.NOM_LAB || '');
    this.modalService.open(modal, { centered: true });
  }

  guardarLaboratorio() {
    const nombre = this.nuevoLaboratorio.trim();
    if (!nombre) return;

    this.guardando = true;
    this.laboratorioService.crearLaboratorio(this.token, nombre).subscribe({
      next: () => {
        this.guardando = false;
        this.toastr.success('Laboratorio guardado correctamente');
        this.modalService.dismissAll();
        this.obtenerLaboratorios();
      },
      error: () => {
        this.guardando = false;
        this.toastr.error('No se pudo guardar');
      }
    });
  }

  actualizarLaboratorio() {
    const nombre = this.editarLaboratorio.trim();
    if (!nombre || !this.idLaboratorioEditar) return;

    this.guardando = true;
    this.laboratorioService.editarLaboratorio(this.token, this.idLaboratorioEditar, nombre).subscribe({
      next: () => {
        this.guardando = false;
        this.toastr.success('Laboratorio actualizado correctamente');
        this.modalService.dismissAll();
        this.obtenerLaboratorios();
      },
      error: () => {
        this.guardando = false;
        this.toastr.error('No se pudo actualizar');
      }
    });
  }

  alternarEstado(lab: any) {
    const estadoActual = Number(lab.EST_LAB || 0);
    const nuevoEstado = estadoActual !== 0 ? 0 : 1;

    this.laboratorioService.actualizarEstadoLaboratorio(this.token, Number(lab.COD_LAB), nuevoEstado).subscribe({
      next: () => {
        lab.EST_LAB = nuevoEstado;
        this.toastr.success('Estado actualizado');
      },
      error: () => {
        this.toastr.error('No se pudo actualizar estado');
      }
    });
  }

  verProveedoresDerivados(lab: any) {
    this.router.navigate(['/sistema/laboratorios/proveedores-derivados', Number(lab.COD_LAB)], {
      queryParams: { nombreLab: String(lab.NOM_LAB || '') }
    });
  }
}

export class LanguageApp {
  public static spanish_datatables = {
    processing: 'Procesando...',
    search: 'Buscar:',
    lengthMenu: 'Mostrar _MENU_ registros',
    info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
    infoEmpty: 'Mostrando ningún elemento.',
    infoFiltered: '(filtrado _MAX_ elementos total)',
    infoPostFix: '',
    loadingRecords: 'Cargando registros...',
    zeroRecords: 'No se encontraron registros',
    emptyTable: 'No hay datos disponibles en la tabla',
    paginate: {
      first: 'Primero',
      previous: 'Ant',
      next: 'Sig',
      last: 'Último'
    },
    aria: {
      sortAscending: ': Activar para ordenar la tabla en orden ascendente',
      sortDescending: ': Activar para ordenar la tabla en orden descendente'
    }
  };
}
